import $ from "jquery";

$(document).on('content-ready', function(ev, container) {
    container.find('form[data-ajax]').submit(function(event) {
        var form = $(this);
        form.find('[type=submit],.submit').startProcess();
        connection.saveForm(form, function(data) {
            if (data.forward) {
                form.find('[type=submit],.submit').startProcess();
                location.href = data.forward;
                return;
            }
            form.find('[type=submit],.submit').endProcess();
            }, {
            disableTaskError: true,
            onError: function() {
                form.find('[type=submit],.submit').endProcess();
            },
            onComplete: function() {
            },
        });
        return false;
    });
    container.find('[data-initLoad]').each(function() {
        connection.loadPart($(this));
    });
    container.find('[data-reload-target]').click(function() {
        var target = $($(this).attr('data-reload-target'));
        if (target.length >= 0) {
            connection.loadPart(target);
        }
    });

    $.each(container.find('[data-filter-form]'), function() {
        var formEl = $(this);
        var target = $(formEl.attr('data-filter-form'));

        container.find('[data-paging-next]').click(function() {
            var itemsPerPage = parseInt(formEl.find('[data-itemsperpage]').attr('data-itemsperpage'));
            var lastPage = parseInt(formEl.find('[data-lastpage]').attr('data-lastpage'));
            container.find('#page').val(Math.min((lastPage - 1) * itemsPerPage, parseInt(container.find('#page').val()) + itemsPerPage));
            formEl.submit();
        });
        container.find('[data-paging-prev]').click(function() {
            var itemsPerPage = parseInt(formEl.find('[data-itemsperpage]').attr('data-itemsperpage'));
            container.find('#page').val(Math.max(0, parseInt(container.find('#page').val()) - itemsPerPage));
            formEl.submit();
        });

        formEl.submit(function() {
            var params = connection.serializePart(formEl);
            target.startProcess();
            connection.getJson(target.attr('data-load-html'), {
                data: params,
                type: 'post',
                onSuccess: function(data) {
                    target.html(data.html.trim());
                    target.trigger('opened');
                    onContentReady(target);
                },
                onComplete: function() {
                    target.endProcess();
                },
                onError: function(err) {
                    debugger;
                },
            });
            return false;
        });

        if (formEl.is('[data-submit-onload]')) {
            formEl.submit();
        }
    });
});

var connection = {
    defaultTimeout: 30000,

    getJson: function(url, options) {
        return $.ajax({
            url: url,
            type: options.type || 'get',
            data: options.data || {},
            async: options.async || true,
            dataType: 'json',
            cache: false,
            timeout: options.timeout || connection.defaultTimeout,
            beforeSend: function() {
                if (options.onBeforeSend != null) options.onBeforeSend();
            },
            complete: function() {
                if (options.onComplete != null) options.onComplete();
            },
            success: function(data) {
                connection.handleResponse(data, options);
                if (options.onSuccess) options.onSuccess(data);
            },
            error: function(data) {
                console.log(data);
                if (data.responseJSON) {
                    connection.handleResponse(data.responseJSON, options);
                }
                if (data.statusText === 'timeout' && options.onTimeout) {
                    console.log('timeout for ' + url);
                    messaging.showGlobalMessage('danger', null, 'Es ist ein Timeout aufgetreten.', 0);
                    options.onTimeout(data);
                    return;
                }
                if (data.status === 401) {
                    messaging.showGlobalMessage('danger', null, 'Du bist nicht mehr eingeloggt. <a href="/Home">Zum Login</a>');
                    return;
                }
                if (options.onError) {
                    options.onError(data.responseJSON, data);
                } else {
                    try {
                        var message = (data.responseJSON.error) ? data.responseJSON.error : 'Fehler beim Laden des Inhalts.' ;
                        if (message !== '--') {
                            messaging.showGlobalMessage('danger', null, message);
                        }
                    } catch (e) {
                        messaging.showGlobalMessage('danger', null, 'Die Rückmeldung des Servers konnte nicht gelesen werden.');
                    }
                }
            },
            fail: function() {
                debugger;
            }
        });
    },

    loadJson: function(url, onComplete, onSuccess, onError) {
        connection.getJson(url, {
            onComplete: onComplete,
            onSuccess: onSuccess,
            onError: onError
        });
    },

    getHtmlPart: function(url, options) {
        return $.ajax({
            url: url,
            type: options.type || 'get',
            dataType: 'html',
            data: options.data || {},
            cache: false,
            timeout: options.timeout || connection.defaultTimeout,
            beforeSend: function() {
                if (options.onBeforeSend != null) options.onBeforeSend();
            },
            complete: function() {
                if (options.onComplete != null) options.onComplete();
            },
            success: function(data) {
                if (options.onSuccess) options.onSuccess(data);
            },
            error: function(data) {
                if (data.statusText === 'timeout' && options.onTimeout) {
                    console.log('timeout for ' + url);
                    messaging.showGlobalMessage('danger', null, 'Es ist ein Timeout aufgetreten.', 0);
                    options.onTimeout(data);
                    return;
                }
                if (data.status === 401) {
                    messaging.showGlobalMessage('danger', null, 'Du bist nicht mehr eingeloggt. <a href="/Home">Zum Login</a>', 0);
                    return;
                }

                if (options.onError) {
                    options.onError(data);
                } else {
                    messaging.showGlobalMessage('danger', null, (data || 'Die Rückmeldung des Servers konnte nicht gelesen werden.'));
                }
            }
        });
    },

    loadPartWith: function(me, options) {
        if (me.length === 0) return;
        var target = me;
        var targetAttr = me.attr('data-target');
        if (typeof targetAttr !== 'undefined' && targetAttr !== false) {
            target = $(targetAttr);
        }
        target.html('');
        target.startProcess();
        if (!options) options = {};
        if (!options.data) options.data = {};
        if (target.is('[data-loadParams]')) {
            var data = JSON.parse(target.attr('data-loadParams'));
            $.each(data, (key, value) => {
                if (value.substring(0, 1) === '[') {
                    data[key] = $(value).val();
                } else {
                    data[key] = value;
                }
            });
            options.data = $.extend(options.data, data);
        }

        if (me.attr('data-entries')) {
            options.data.entries = parseInt(me.attr('data-entries'));
        }
        if (options.nextPage) {
            me.attr('data-page', parseInt(me.attr('data-page')) + parseInt(me.attr('data-entries')));
            options.data.paging = me.attr('data-page');
        }
        if (options.prevPage) {
            me.attr('data-page', Math.max(parseInt(me.attr('data-page')) - parseInt(me.attr('data-entries')), 0));
            options.data.paging = me.attr('data-page');
        }
        options.dataType = me.attr('data-dataType') || 'html';

        $.ajax({
            url: me.attr('data-loadPart'),
            type: 'get',
            dataType: options.dataType,
            cache: false,
            data: options.data,
            timeout: connection.defaultTimeout,
            complete: function() {
                target.endProcess();
                if (options.onComplete != null) options.onComplete();
            },
            success: function(data) {
                if (options.dataType === 'json') {
                    if (data.content) {
                        target.html($(data.content.trim()));
                    }
                    connection.handleResponse(data, options);
                }
                if (options.dataType === 'html') {
                    target.html(data);
                }
                onContentReady(target);
                target.trigger('onLoaded', {target: target});
                if (options.onSuccess) options.onSuccess(data, target);
            },
            error: function(data) {
                if (data.statusText === 'timeout' && options.onTimeout) {
                    console.log('timeout for ' + me.attr('data-loadPart'));
                    options.onTimeout(data);
                    return;
                }
                if (data.status === 401) {
                    messaging.showGlobalMessage('danger', null, 'Du bist nicht mehr eingeloggt. <a href="/Home">Zum Login</a>');
                    return;
                }
                if (options.onError) {
                    options.onError(data);
                } else {
                    var message = 'Fehler beim Laden des Inhalts.';
                    try {
                        var parsedData = JSON.parse(data);
                        if (parsedData.error) message = parsedData.error;
                    } catch (e) {
                    }
                    if (message !== '--') {
                        messaging.showGlobalMessage('danger', null, message);
                    }
                }
            }
        });
    },

    loadPart: function(me, onComplete, onSuccess, onError, onTimeout) {
        connection.loadPartWith(me, {
            onComplete: onComplete,
            onSuccess: onSuccess,
            onError: onError,
            onTimeout: onTimeout
        });
    },

    executeSaveTask: function(url, postData, onSuccess, onError) {
        var task = {
            run: function(onComplete, onTaskError) {
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: postData,
                    cache: false,
                    timeout: connection.defaultTimeout,
                    success: function(data) {
                        if (onSuccess) onSuccess(data);
                        if (data.fields) {
                            connection.updateFields(data.fields);
                        }
                    },
                    error: function(data) {
                        if (data.statusText === 'timeout') {
                            // onTaskError(null, true);
                            return;
                        }
                        if (data.status === 401) {
                            messaging.showGlobalMessage('danger', null, 'Du bist nicht mehr eingeloggt. <a href="/Home">Zum Login</a>');
                            return;
                        }
                        onTaskError(connection.getErrorMessageOf(data, 'Fehler beim Speichern.'), false, function() {
                            //revert
                            if (onError) onError();
                        });
                    },
                    complete: function() {
                        if (onComplete != null) onComplete();
                    }
                });
            }
        };
        taskQueue.add(task);
    },

    handleResponse: function(data, options) {
        data = data || {};
        if (data.reload) {
            $('body').changeLoader('Seite wird neu geladen');
            location.reload();
        }
        if (data.fields) {
            connection.updateFields(data.fields);
        }
        if (data.updateDom) {
            connection.updateDom(data.updateDom);
        }
        if (data.removeDom) {
            connection.removeDom(data.removeDom);
        }
        if (data.loadParts) {
            $.each(data.loadParts, function(i, part) {
                connection.loadPart($(part));
            });
        }
        if (data.openSlidein) {
            slidein.loadSlideIn(data.openSlidein, null, data.openSlideinOptions || {});
        }
        if (data.closeSlidein) {
            slidein.close();
        }
        if ((data.message || '') !== '') {
            if ((data.message || '') !== '--') {
                messaging.showGlobalMessage('success', null, data.message, options.messageTimeout || 2000);
            }
        }
        if (data.redirect) {
            location.href = data.redirect;
        }
    },

    saveForm: function(form, onSuccess, options) {
        if (form.attr('data-status') === 'pending') {
            return;
        }
        options = options || {};
        if (!options.onSuccess) options.onSuccess = onSuccess;
        form.find('.invalid-feedback').empty();
        form.find('.is-invalid').removeClass('is-invalid');

        form.attr('data-status', 'pending');
        var task = {
            run: function(onComplete, onTaskError) {
                var params = form.find('input,textarea,select').not('.dont-send').serializeArray();
                $.each(form.find('[contenteditable]'), function() {
                    params.push({name: $(this).attr('name') || $(this).attr('data-name'), value: $(this).text()});
                });
                $.ajax({
                    url: options.action || form.attr('action') || form.attr('data-action'),
                    data: params,
                    type: 'post',
                    dataType: options.dataType || 'json',
                    cache: false,
                    timeout: connection.defaultTimeout,
                    complete: function() {
                        form.attr('data-status', '');
                        if (options.onComplete) options.onComplete(form);
                        if (onComplete != null) onComplete();
                        form.trigger('onComplete', {target: form});
                    },
                    success: function(data) {
                        connection.addFormErrors(form, null);
                        if (options.onSuccess) options.onSuccess(data);
                        form.trigger('onSuccess', {target: form, data: data});

                        if ((options.dataType || 'json') === 'json') {
                            data.message = data.message || 'Speichern erfolgreich';
                            connection.handleResponse(data, options);
                        }
                    },
                    error: function(data) {
                        if (options.onError) options.onError(data);
                        if (data.statusText === 'timeout' && onTaskError) {
                            onTaskError(null, true);
                            return;
                        }
                        if (data.responseJSON && data.responseJSON.error) {
                            if (data.responseJSON.error !== '--') {
                                messaging.showGlobalMessage('error', null, data.responseJSON.error, 0);
                            }
                        }
                        if (options.disableTaskError || false) {
                            connection.addFormErrors(form, data.responseJSON);
                        } else {
                            if (onTaskError) onTaskError(connection.getErrorMessageOf(data, 'Speichern fehlgeschlagen'), false, function () {
                                connection.addFormErrors(form, data.responseJSON);
                            });
                        }
                        if (options.onErrorsAppended) options.onErrorsAppended(data);
                    }
                });
            }
        };
        if (options.onlyRun) {
            task.run();
        } else {
            taskQueue.add(task);
        }
    },

    delay: function(delay, callback) {
        setTimeout(function() {
            callback();
        }, delay);
    },

    serializePart: function(container) {
        return container.find('input,textarea,select').not('.dont-send').serialize();
    },

    getErrorMessageOf: function(data, defaultError) {
        if (data && data.responseJSON != null && data.responseJSON.error != null) {
            return data.responseJSON.error;
        }
        if (data && data.error != null) {
            return data.error;
        }

        return defaultError;
    },

    addFormErrors: function(form, jsonData) {
        form.find('.is-invalid').removeClass('is-invalid');
        form.find('.invalid-feedback').remove();

        if (jsonData != null) {
            $.each(jsonData.errors || {}, function(index, item) {
                var field = form.find('.'+item.field+'-error');
                if (field.length === 0) {
                    field = form.find('[name="'+item.field+'"]');
                }
                if (field.length >= 1) {
                    field.addClass('is-invalid');
                    field.closest('.form-part,.form-group').addClass('is-invalid');
                    var exFeedback = field.closest('.form-part,.form-group').find('.invalid-feedback');
                    if (exFeedback.length === 1) {
                        exFeedback.append('<li>'+item.message+'</li>');
                    } else {
                        $('<ul class="invalid-feedback"><li>' + item.message + '</li></ul>').appendTo(field.parent());
                    }
                }

                // var field = form.find('[name="'+item.field+'"]');
                // if (field.length >= 1) {
                //     var container = field.parent();
                //     container.addClass('is-invalid');
                //     var errorContainer = container.find('.error-container');
                //     if (errorContainer.length >= 1) {
                //         $('<div class="invalid-feedback">' + item.message + '</div>').appendTo(errorContainer);
                //     } else {
                //         container.append($('<div class="invalid-feedback">' + item.message + '</div>'));
                //     }
                // }
            });
        }
    },

    applyValueChange: function(fields, options) {
        $.each(fields, function() {
            var me = $(this);
            if (!me.is('[data-val]')) {
                me.attr('data-val', connection.getEditableValue(me, options));
            }
        });
        fields.off(options.changeEvent || 'blur').on(options.changeEvent || 'blur', function() {
            var me = $(this);
            if (options.onLeave) options.onLeave(me);
            var value = connection.getEditableValue(me, options).trim();
            var oldValue = me.attr('data-val');
            if (me.attr('data-val').trim() !== value) {
                me.attr('data-val', value);
                if (options.onChange) options.onChange(me, oldValue, value);
                me.trigger('valueChange', [me, oldValue, value]);
            }
        });
    },

    getEditableValue: function(el, options) {
        var value = '';
        var tagName = el.prop("tagName");
        if (options.getValue == null) {
            if (tagName === "INPUT" || tagName === "TEXTAREA" || tagName ===  "SELECT") {
                value = el.val();
            } else if (el.is('.htmlEditor')) {
                value = el.html();
            } else if (el.is('.html-editor')) {
                value = el.html();
                if (el.data('editor')) {
                    value = el.data('editor').getData();
                }
            } else {
                value = el.text();
            }
        } else {
            value = options.getValue(el);
        }
        return value;
    },

    setUserOption: function(key, value) {
        $.ajax({
            url: '/Auth/SetUserOption',
            data: {
                key: key,
                value: value
            },
            type: 'post',
            dataType: 'json',
            cache: false,
            timeout: connection.defaultTimeout,
            success: function(data) {
            },
            error: function(data) {
                messaging.showPermanentGlobalMessage('danger', null, 'Speichern fehlgeschlagen');
            }
        });
    },

    getUserOption: function(key) {
        var value = null;
        $.ajax({
            url: '/Auth/GetUserOption',
            data: {
                key: key
            },
            type: 'post',
            dataType: 'json',
            cache: false,
            async: false,
            timeout: connection.defaultTimeout,
            success: function(data) {
                value = data.value;
            }
        });
        return value;
    },

    updateFields: function(data) {
        $.each(data, function(i, value) {
            var els = $('#' + i + ', .' + i);
            if (els.length >= 1) {
                $.each(els, function(i, el) {
                    var me = $(el);
                    if (value == null) {
                        value = '';
                    }
                    if (typeof value === 'object') {
                        $.each(value, function(name, content) {
                            if (name === "html") {
                                me.html(content);
                            } else {
                                me.attr(name, content);
                            }
                        });
                    } else {
                        if (el.tagName === 'INPUT') {
                            me.val(value);
                            me.attr('data-val', value);
                        } else {
                            me.html(value);
                        }
                    }
                });
            } else {
                console.log("Das Feld " + i + " wurde nicht gefunden !!");
            }
        });
    },

    updateDom: function(array) {
        $.each(array, function(index, value) {
            if (value === null) value = '';
            if (typeof value === 'string' || typeof value === 'number') {
                $(index).html(value);
            } else if (typeof value === 'object') {
                $.each(value, function(name, content) {
                    switch (name) {
                        case "removeClass":
                            $(index).removeClass(content);
                            break;
                        case "addClass":
                            $(index).addClass(content);
                            break;
                        default:
                            $(index).attr(name, content);
                    }
                });
            }
        });
    },

    removeDom: function(array) {
        $.each(array, function(index, value) {
            if (typeof index === 'string') {
                $(index).remove();
            }
        });
    }

};
window.connection = connection;
